import { render, staticRenderFns } from "./imovirtual.vue?vue&type=template&id=497307e2"
import script from "./imovirtual.vue?vue&type=script&lang=js"
export * from "./imovirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports